import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuthStore } from '../../store/authStore'
import { FullPageSpinner } from '../ui/Spinner'

export function ProtectedRoute() {
  const { isAuthenticated, isInitializing, forcePasswordChange } = useAuthStore()
  const location = useLocation()

  if (isInitializing) return <FullPageSpinner />

  if (!isAuthenticated) return <Navigate to="/login" replace />

  if (forcePasswordChange && location.pathname !== '/auth/change-password') {
    return <Navigate to="/auth/change-password" replace />
  }

  return <Outlet />
}
